module.exports = __webpack_public_path__ + "img/triple_silver.3a483ae5.svg";